<template>
 <div>
    <h2>Dashboard</h2>
    <a class="ui yellow label">NEU</a>&nbsp;&nbsp;<button class="ui basic button" @click="openTouren()">Touren</button><br><br>
    <button class="ui basic button" @click="openOperations()">Operationen</button>

  </div>

</template>

<script>

import Config from '../Config';
import User from '../enteties/User';

export default {
  name: 'Dashboard',
  props: {},
  data: function() {
    return {
      config: Config,
      user: User
    }
  },
  created: function() {
    if(!this.user.logedin){
        this.$router.push({ path: 'login' })
    }
  },
  methods: {
    openTouren: function(){
        this.$router.push({ path: 'touren' })
    },
    openOperations: function(){
        this.$router.push({ path: 'operations' })
    }
  }
}
</script>

<style>

</style>
